import { isBrowser } from '~/shared/utils/platform';

export default function getUrl(path: string) {
    return new URL(
        path,
        (isBrowser ? globalThis.location.protocol : 'http:') + process.env.NEXT_PUBLIC_LOOP54_URL
    );
}
